import {_} from 'lodash';
import * as ko from "knockout";
import {
    IMessageData,
    IObjectData,
    IRule,
    ISearchObjectParams,
    TBaseOrObservableOrFunctionType,
    TDataSourceType,
    TSyncfield
} from "../../index";
import PromiseRequest from "../../req/PromiseRequest";
import {ObjectTypeId} from "../../constants";
import {
    _d,
    createErrorMessage,
    getObjectDefinition,
    getObjectType,
    getSyncFieldDisplayName,
    IObjectDefinition
} from "../../util/misc";
import {global} from "../../appContext";
import {getSearchObjectParams} from "../../util/request";
import {nsSyncFields} from "../../req/nsSyncFields";
import {nsTooltip} from "../../util/nsTooltip";
import {getHash} from "../../constants/RouteDefinitions";
import getSyncfieldIdsFromNames = nsSyncFields.getSyncfieldIdsFromNames;
import object_by_anyHtml from './object-by-any.html?raw';

export let template: string = object_by_anyHtml;

interface IParams {
    argument: string | number
    argumentoperator?: string
    attr?: any
    attribute: TSyncfield
    data?: IObjectData
    datasources?: TDataSourceType
    getDisplayName?: (obj: IObjectData) => string
    getId?:(obj: IObjectData) => string
    getLink?: (obj: IObjectData) => string
    icon?: TBaseOrObservableOrFunctionType<string>
    linkable?: boolean
    target?: string
    objectTypeId: ObjectTypeId
    rules?: IRule[]
    searchParams?: ISearchObjectParams
    showIcon?: boolean
    showNoData?: boolean
    syncfieldNames?: TSyncfield[]
    onLoad?: (o: IObjectData) => void
}

export class viewModel {
    isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private req_searchobject: PromiseRequest = global.getPromiseRequest("searchobject");
    private objDef: IObjectDefinition | null = null;
    private data!: IObjectData;
    private objectTypeId: ObjectTypeId;
    private isRequesting = ko.observable(false)

    constructor(private params: IParams) {
        params.showNoData = params.showNoData ?? true;
        params.linkable = params.linkable ?? true;
        params.showIcon = params.showIcon ?? false;
        if (params.data) {
            this.data = params.data;
            this.objectTypeId = params.data.type.id
        } else {
            this.objectTypeId = params.objectTypeId
        }
        if (!this.objectTypeId) {
            _d.warn('No object type id set', this.objectTypeId)
        }
        this.objDef = getObjectDefinition(this.objectTypeId);
        if (!this.objDef) {
            _d.warn('No object definition for type', this.objectTypeId)
            return;
        }
        if (params.data) {
            this.isReady(true);
        } else {
            this.request();
        }
    }

    protected request() {

        this.isReady(false);

        const ruleset = {
            authdatasources: this.params.datasources ?? '',
            objecttype: getObjectType(this.params.objectTypeId),
            rules: _.defaults(this.params.rules ?? [{
                argument: this.params.argument,
                argumentoperator: this.params.argumentoperator || 'Er lik',
                attribute: this.params.attribute,
            }])
        };

        this.isRequesting(true)
        if (!this.objDef) {
            return;
        }
        getSyncfieldIdsFromNames(this.objDef!.id, ...(this.objDef!.syncfieldDisplayName ?? []).concat(this.params.syncfieldNames ?? []))
            .then((syncfieldids: string) => {
                const params: ISearchObjectParams = _.extend(getSearchObjectParams({
                    jruleset: JSON.stringify(ruleset),
                    objecttypeid: this.params.objectTypeId,
                    syncfieldids,
                }), this.params.searchParams || {});
                this.req_searchobject
                    .request(params)
                    .then((data: IObjectData[]) => {
                        this.isRequesting(false)
                        this.messageData(null);
                        const item = data[0];
                        if (!item) {
                            this.messageData(this.params.showNoData ? {message: "data not available", type: "warning"}: null);
                        } else {
                            this.data = item;
                            this.params.onLoad?.(this.data)
                            this.messageData(null);
                            this.isReady(true);
                        }
                    })
                    .catch((reason: string) => {
                        this.isRequesting(false)
                        this.messageData(createErrorMessage(String(reason)));
                    });
            })

    }

    protected getDisplayName(): string {
        if ('getDisplayName' in this.params && this.data) {
            return this.params.getDisplayName!(this.data)
        }
        if (!this.data) {
            return '';
        }
        return getSyncFieldDisplayName(this.params.objectTypeId ?? this.data.type.id, this.data.syncfields)
    }

    protected getLink(): string {
        if ('getLink' in this.params && this.data) {
            return this.params.getLink!(this.data)
        }
        if (!this.objDef?.routeDetails || !this.data) {
            return '';
        }
        return getHash(this.objDef.routeDetails, {id: this.data.id}) ?? ''
    }

    private getAttr() {
        const attr: any = {}
        let title = nsTooltip.getTitle_objectdata(this.data)
        attr.title = title
        attr.target = this.params.target
        if (this.params.linkable) {
            attr.href = this.getLink()
        }
        return _.defaults((this.params.attr ?? {}), attr)
    }

    dispose() {
        this.req_searchobject.abort();
    }

}
